// extracted by css-extract-rspack-plugin
export default {"colorWhite":"#fff","dialog":"dialog__dialog___Y1FGy","root":"dialog__root___gq5Yy"};